module.exports = __webpack_public_path__ + "static/media/loc7_img4.b759d3df.jpg";